import { withSvgIcon } from './withSvgIcon';

export const NoDataCoinStack = withSvgIcon(
  <>
    <ellipse
      cx="11.5"
      cy="6.5"
      rx="5.5"
      ry="2.5"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinejoin="round"
    />
    <path
      d="M11.5 18C8.46243 18 6 16.6569 6 15"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinejoin="round"
    />
    <path
      d="M17 11C17 12.1046 14.5376 13 11.5 13C8.46243 13 6 12.1046 6 11"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinejoin="round"
    />
    <path
      d="M11.5 22C8.46243 22 6 20.7359 6 19.1765V6.5M17 6.5V11"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinejoin="round"
    />
    <circle
      cx="19"
      cy="20"
      r="5"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path d="M17 20H21" stroke="currentColor" strokeWidth="currentWidth" />
  </>,
  { viewBox: '0 0 28 28' },
);
